import { jsx as _jsx } from "react/jsx-runtime";
import { VideoContainer as PrestylesVideoContainer } from '@streamr/tv-ui';
import styled from 'styled-components';
import { VideoPropertiesService } from '../services/videoProperties/VideoPropertiesService';
const DEFAULT_FIT = (videoType) => videoType === 'camera' ? 'cover' : 'contain';
export function VideoDisplay(props) {
    const { component, fit: fitProp = DEFAULT_FIT, hud, orientToScreen, } = props;
    const videoProperties = VideoPropertiesService.getOutput().useVideoProperties();
    const videoType = videoProperties?.type ?? 'camera';
    const fit = typeof fitProp === 'function' ? fitProp(videoType) : fitProp;
    return (_jsx(VideoContainer, { allowUpscale: true, canvas: component, center: true, fit: fit, hud: hud, orientToScreen: orientToScreen, videoHeight: videoProperties?.height ?? 0, videoRotation: videoProperties?.rotation ?? 0, videoWidth: videoProperties?.width ?? 0 }));
}
const VideoContainer = styled(PrestylesVideoContainer) `
    pointer-events: none;
`;
